import React from 'react';
import { Navigate } from 'react-router-dom';
import FallbackSpinner from '@/components/FallbackSpinner';
import { usePermissions } from '@/hooks/usePermissions';
import type { NavigationPermissionRequirement } from '@/types/navigation-permissions';

interface WriteRouteGuardProps {
  requiredPermission: NavigationPermissionRequirement;
  children: React.ReactNode;
}

/**
 * Blocks write-only routes when the user lacks create/update permission.
 * Complements list/read route guards for READ_ONLY and similar roles.
 */
export const WriteRouteGuard: React.FC<WriteRouteGuardProps> = ({
  requiredPermission,
  children,
}) => {
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading) {
    return <FallbackSpinner />;
  }

  if (!hasPermission(requiredPermission.feature, requiredPermission.action)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default WriteRouteGuard;
